import { render, staticRenderFns } from "./GLADetails.vue?vue&type=template&id=ede2e0d4&scoped=true&"
import script from "./GLADetails.vue?vue&type=script&lang=js&"
export * from "./GLADetails.vue?vue&type=script&lang=js&"
import style0 from "./GLADetails.vue?vue&type=style&index=0&id=ede2e0d4&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ede2e0d4",
  null
  
)

export default component.exports